if (!window.colorSwatchesInitialized) {
  window.colorSwatchesInitialized = true;

  function initColorSwatches() {
    document.querySelectorAll('.card-wrapper').forEach(function (card) {
      if (card.dataset.swatchesInit) return;
      card.dataset.swatchesInit = 'true';

      const swatches = card.querySelectorAll('.card-color-swatch');
      if (swatches.length === 0) return;

      swatches.forEach(function (swatch) {
        swatch.addEventListener('mouseenter', function (e) {
          e.stopPropagation();
          const variantImage = swatch.dataset.variantImage;
          if (variantImage) {
            const img = card.querySelector('img.motion-reduce');
            if (img) img.src = variantImage;
          }
        });

        swatch.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          const variantUrl = swatch.dataset.variantUrl;
          if (variantUrl) {
            window.location.href = variantUrl;
          }
        });

        swatch.addEventListener('mouseover', function (e) {
          e.stopPropagation();
        });

        swatch.addEventListener('pointerdown', function (e) {
          e.stopPropagation();
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initColorSwatches);

  const swatchObserver = new MutationObserver(function () {
    initColorSwatches();
  });

  swatchObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
}
